























































































































































































































































































import {
  Department,
  Forms,
  StaffSurveyFormResponse,
  StaffSurveyQuestion,
} from "@/api";
import { Component, Ref, Vue } from "vue-property-decorator";
import { requiredString, noSpace } from "@/tool/validation";
import { VForm } from "@/common/vuetify_types";
import { selfData } from "@/common/role_utils";
import ConfirmationModule from "@/components/confirmationModule/ConfirmationModule.vue";
import PublishDialog from "./PublishDialog.vue";
import draggable from "vuedraggable";

@Component({
  components: {
    ConfirmationModule,
    draggable,
    PublishDialog,
  },
})
export default class Question extends Vue {
  @Ref("form") readonly form!: VForm;
  formModel = false;
  departmentID = 0;
  question = "";
  title = "";
  subTitle = "";
  loading = true;
  companyId = selfData().companyId;
  required_text = [requiredString, noSpace];
  selectEditingQuestion: StaffSurveyQuestion | null = null;
  saving = false;
  deleting = false;
  deleteDialog = false;
  confirmPublish = false;
  publishing = false;
  savingDraft = false;
  isEdit = false;
  isRequired = false;
  textRules = [requiredString];
  questionTypes = [
    { text: "Text", value: "text" },
    { text: "Rating", value: "rating" },
    // { text: "Multiple Choice", value: "multiple_choice" },
    { text: "Multiple Choice", value: "multi_choice" },
    { text: "Single Choice", value: "single_choice" },
    { text: "Yes/No", value: "yes_no" },
  ];
  questionType = "";
  optionsList = [{ id: 0, questionId: 0, label: "", value: 1, order: 1 }];

  required_select = (v: string) =>
    (v !== "" && v !== undefined && v != "0") || "Required";

  async created() {
    const formId = this.$route.params.formId;
    this.loading = true;
    if (formId)
      await this.$store.dispatch("staffSurvey/getStaffSurveyForm", {
        formId,
        slug: this.getDispatchType(),
      });
    this.loading = false;
  }

  addOption() {
    this.optionsList.push({
      id: 0,
      questionId: 0,
      label: "",
      value: this.optionsList.length,
      order: this.optionsList.length + 1,
    });
  }

  removeOption(index: number) {
    this.optionsList.splice(index, 1);
    // re-sync order after removal
    this.optionsList.forEach((opt, i) => {
      opt.order = i + 1;
    });
  }

  get departments(): Department[] {
    return this.$store.getters["company/departments"]?.map(
      (item: Department) => {
        return {
          ...item,
          header: undefined,
        };
      },
    );
  }

  clearForm() {
    this.selectEditingQuestion = null;
    this.departmentID = 0;
    this.question = "";
    this.isEdit = false;
    this.title = "";
    this.subTitle = "";
    this.questionType = "";
    this.optionsList = [
      { id: 0, questionId: 0, label: "", value: 1, order: 1 },
    ];
    this.form.reset();
    this.form.resetValidation();
  }

  get questions(): StaffSurveyQuestion[] {
    const form = this.$store.getters[
      "staffSurvey/selectedForm"
    ] as StaffSurveyFormResponse;
    return form?.questions || [];
  }

  // Need to make api for sort questions to use this setter
  set questions(values: StaffSurveyQuestion[]) {
    const requestBody = values.map((item, index) => {
      return {
        ...item,
        order: index,
      };
    });

    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    this.$store.dispatch("staffSurvey/sortStaffSruveyFormQuestion", {
      requestBody,
      slug: this.getDispatchType(),
      formId,
    });
  }

  async submit() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    if (this.form.validate()) {
      this.saving = true;
      const requestBody = {
        id: 0,
        slug: this.getDispatchType(),
        departmentID: this.departmentID,
        question: this.question,
        questionType: this.questionType,
        isRequired: this.isRequired,
        order: this.questions.length + 1,
        title: this.title,
        subTitle: this.subTitle,
        options:
          this.questionType == "single_choice" ||
          this.questionType == "multiple_choice" ||
          this.questionType == "multi_choice"
            ? this.optionsList
            : this.questionType == "yes_no"
            ? [
                { id: 0, questionId: 0, label: "Yes", value: 1, order: 1 },
                { id: 0, questionId: 0, label: "No", value: 0, order: 2 },
              ]
            : [],
        createdAt: new Date().toISOString(),
        updatedAt: null,
      } as StaffSurveyQuestion;

      await this.$store.dispatch("staffSurvey/createStaffSruveyFormQuestion", {
        requestBody,
        formId,
        slug: this.getDispatchType(),
      });
      this.saving = false;
      this.clearForm();
    }
  }

  getDispatchType() {
    const pathType = this.$route.params.slug;
    if (pathType.includes("orientation")) return "staff-orientation";
    else if (pathType.includes("satisfaction")) return "staff-satisfaction";
    else if (pathType.includes("exit")) return "staff-exit";
    else return pathType;
  }

  async update() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to update question");
      return;
    }
    if (this.form.validate()) {
      this.saving = true;
      const requestBody = {
        id: this.selectEditingQuestion?.id || 0,
        slug: this.getDispatchType(),
        departmentID: this.departmentID,
        question: this.question,
        questionType: this.questionType,
        isRequired: this.isRequired,
        order: this.questions.length + 1,
        title: this.title,
        subTitle: this.subTitle,
        options:
          this.questionType == "single_choice" ||
          this.questionType == "multiple_choice"
            ? this.optionsList
            : [],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      } as StaffSurveyQuestion;

      await this.$store.dispatch("staffSurvey/updateStaffSruveyFormQuestion", {
        requestBody,
        formId,
        slug: this.getDispatchType(),
      });
      this.saving = false;
      this.clearForm();
    }
  }

  editQuestion(question: StaffSurveyQuestion) {
    this.question = question.question;
    this.title = question.title || "";
    this.subTitle = question.subTitle || "";
    this.departmentID = question.departmentId || 0;
    this.optionsList = question.options || [];
    this.questionType = question.questionType || "";
    this.isRequired = question.isRequired || false;

    this.isEdit = true;
    this.selectEditingQuestion = question;
  }

  async removeQuestion(question: StaffSurveyQuestion) {
    this.selectEditingQuestion = question;
    this.deleteDialog = !this.deleteDialog;
  }

  async confirmRemove() {
    const formId = Number(this.$route.params.formId);
    if (!formId || this.selectEditingQuestion == null) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    this.selectEditingQuestion.slug = this.getDispatchType();
    this.deleting = true;
    await this.$store.dispatch("staffSurvey/deleteStaffSruveyFormQuestion", {
      requestBody: this.selectEditingQuestion,
      formId,
      slug: this.getDispatchType(),
    });
    this.clearForm();
    this.deleting = false;
    this.deleteDialog = !this.deleteDialog;
  }

  back() {
    this.$router.back();
  }

  async publish() {
    const formId = Number(this.$route.params.formId);
    const forms = JSON.parse(
      JSON.stringify(this.$store.getters["staffSurvey/staffSurveyForms"] || []),
    ) as Forms;
    const requestBody = forms.filter(form => form.id === formId);
    if (!formId || !forms || requestBody.length == 0) {
      this.$store.dispatch("alert/warning", "failed to publish form");
      return;
    }

    const form = requestBody[0];
    form.status = 3;
    this.publishing = true;
    await this.$store.dispatch("staffSurvey/updateStaffSurveyForm", {
      requestBody: form,
      slug: this.getDispatchType(),
      formId,
    });
    this.publishing = false;
    this.confirmPublish = !this.confirmPublish;
  }

  checkStandardQuestion(): boolean {
    if (this.selectEditingQuestion) {
      return this.selectEditingQuestion.id <= 0;
    }

    return false;
  }
}
